/** item 7 · PWA 公司會議室清單（/ee_pwa_office_meetings）。手機「會議室」磚導向此頁。 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Card, CardActionArea, Chip, Stack, Typography } from '@mui/material';

import { useMessage } from '../../../contexts/MessageContext';
import { formatLocalDate, formatLocalTimeShort } from '../../../utils/dateHelper';
import { listMeetings, OfficeMeeting } from '../officeMeeting/services/officeMeetingService';

const STATUS_COLOR: Record<string, 'default' | 'warning' | 'success'> = {
  scheduled: 'default', in_progress: 'warning', ended: 'success', cancelled: 'default',
};

const OfficePwaMeetingsListPage: React.FC = () => {
  const nav = useNavigate();
  const { t } = useTranslation();
  const tt = (k: string, d: string) => t(`officeMeeting.${k}`, d);
  const { showApiError } = useMessage();
  const [rows, setRows] = React.useState<OfficeMeeting[]>([]);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    listMeetings().then(setRows).catch(showApiError).finally(() => setLoaded(true));
  }, [showApiError]);

  return (
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Typography variant="h6" sx={{ fontWeight: 700 }}>🏢 {tt('roomTitle', '會議室')}</Typography>
      {loaded && rows.length === 0 && (
        <Typography variant="body2" color="text.disabled">{tt('empty', '目前沒有會議')}</Typography>
      )}
      {rows.map((m) => (
        <Card key={m.id} variant="outlined">
          <CardActionArea onClick={() => nav(`/ee_pwa_office_meetings/${m.id}`)} sx={{ p: 1.5 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="body2" sx={{ fontWeight: 600 }}>{m.title}</Typography>
              <Chip size="small" color={STATUS_COLOR[m.status] || 'default'}
                label={tt(`status_${m.status}`, m.status)} />
            </Stack>
            <Typography variant="caption" color="text.secondary">
              {formatLocalDate(m.start_at)} {formatLocalTimeShort(m.start_at)} · {m.meeting_no}
              {m.chair_name ? ` · ${tt('chair', '主席')}：${m.chair_name}` : ''}
            </Typography>
          </CardActionArea>
        </Card>
      ))}
    </Box>
  );
};

export default OfficePwaMeetingsListPage;
